import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import './common.css';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import chatlnpfp from './Userpfpc';
import usrf1 from './imgs/grlpfp.png';
import usrm1 from './imgs/boypfp.png';
import {unmountComponentAtNode} from 'react-dom';
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';
import {setusersinactiondv,setuseraction,removeusers} from './userdefaultdata';

import { io } from 'socket.io-client';

//const socket = io('http://localhost:5000', {
//  transports: ['websocket'] // Bypass polling
//});

const socket = io('https://69.197.168.84:8000', {
 transports: ['websocket'] // Bypass polling
});
function ReceiverPublicvilla() {
  const [message, setMessage] = useState('sucess');
  const [receivedData, setReceivedData] = useState([{uid:0,msg:'',pfpid:0,utid:0,uname:'',code:'ffff',utype:false,vid:0}]);
  const [isConnected, setIsConnected] = useState(false);
    const villaid = Usersession.getVillaId();

  useEffect(() => {
    // Connect to the server
 
   socket.on('connect', () => {
      setIsConnected(true);
  
    });

socket.on('frmchangedvilla', (data) => {
       const rdata = data.data;
      const dvid = Usersession.getVillaId();
     if(rdata){
      const userpfpobj = JSON.parse(rdata);
      const userid = userpfpobj.uid;
     const utp = userpfpobj.utf;
     const name = userpfpobj.uname;
     const vid = userpfpobj.vid;
      const pfid = userpfpobj.pfpid;

       const pfpobj = {uid:userid,pfpid:pfid,utf:utp,uname:name,x:'0px',y:'0px'};
       const adrmvillas =  Usersession.getVilladdremv();
       const addvla = adrmvillas.add;
       const rmvla = adrmvillas.remove;
             //alert(addvla);
         var villauserpfp = Usersession.getVillapfps();

       if(vid.toString() == addvla.toString() && addvla > 0){
       	       const villapfps = villauserpfp.concat(pfpobj);
               Usersession.setVillapfps(villapfps);
      }
       else if(vid.toString() == rmvla.toString() && rmvla > 0)  {
	      const removevillapfps= removeusers(villauserpfp,userid);
              Usersession.setVillapfps(removevillapfps);
       }
          setuseraction(dvid,villauserpfp);

      
    }

  });


socket.on('rcvfrmlearing', (data) => {
          const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });


socket.on('rcvfrmculture', (data) => {
           const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });


socket.on('rcvfrmhealth', (data) => {
        const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });


socket.on('rcvfrmsience', (data) => {
           const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });


socket.on('rcvfrmclassic', (data) => {
           const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });


socket.on('rcvfrmurban', (data) => {
           const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });


socket.on('rcvfrmaltmorden', (data) => {
           const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });

  socket.on('rcvfrmnature', (data) => {
        const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });
 socket.on('rcvfrmvillage', (data) => {
         const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();
      }

      //      alert(JSON.stringify(chdata));
    });
  socket.on('rcvfrmmorden', (data) => {
      const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }
      //      alert(JSON.stringify(chdata));
    });
 


  socket.on('rcvfrmpublic', (data) => {
        const uservillaid = Usersession.getVillaId();
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     if(rdata.vid == uservillaid){
      const aftrrcvdata =  chdata.concat(rdata)
      Usersession.setVillachat(aftrrcvdata);
       setReceivedData(aftrrcvdata);
       scrolling();

      }

      //      alert(JSON.stringify(chdata));
    });
 
  socket.on('rcvfrmpvtvilla', (data) => {
      //alert(data.data);
      var chdata = Usersession.getVillachat();
      const rdata = JSON.parse(data.data);
     const uvtid  = Usersession.getVillatype();

     const uvid  = Usersession.getVillaId();
      const rvid = rdata.vid;
     if(rvid == uvid && uvtid == '2'){
      const aftrrcvdata =  chdata.concat(rdata)
      //chdata.push(rdata);
      Usersession.setVillachat(aftrrcvdata);
      setReceivedData(aftrrcvdata);
       scrolling();

        //  alert(JSON.stringify(chdata));

     }
        //  alert(JSON.stringify(chdata));
    });
 
    return () => {
      socket.off('sendmessage');
      socket.disconnect();
    };
  }, []); // Empty dependency array ensures this runs once on mount
const sendMessage = (event:any) => {
 const usermsg = Usersession.getVumsg();

   setMessage(usermsg);
    const clrcd = Usersession.getColorcode();

const userid = Usersession.getUserId();
 const dvid = Usersession.getVillaId();

const vtpid = Usersession.getVillatype();

const objuser = Usersession.getUserpfp();
const pfid = objuser.pfpid;
const utp = objuser.utf;
const name = objuser.uname;
const utpid = objuser.utpid;
// Usersession.setVumsg('');

const chatdata = {uid:userid,msg:usermsg,pfpid:pfid,utid:utpid,uname:name,code:clrcd,utype:utp,vid:dvid};
const strdata = JSON.stringify( chatdata); 

const villastatus = Usersession.getVillasts();
try {

	 if(villastatus != 0){
           setReceivedData([{uid:0,msg:'',pfpid:0,utid:0,uname:'',code:'ffff',utype:false,vid:0}]); 
           Usersession.setVillasts(0);
        }else{
       // alert(dvid);
         if (usermsg !=  null) {
          if(vtpid == '1'){
           if(dvid == 1)
                        socket.emit('sendtomorden', strdata );
          else if(dvid == 2)
                        socket.emit('sendtovillage', strdata );
          else if(dvid == 3)
                        socket.emit('sendtonature', strdata );
          else if(dvid == 4)
                        socket.emit('sendtoaltmordn', strdata );
          else if(dvid == 5)
                        socket.emit('sendtourban', strdata );
          else if(dvid == 6)
                        socket.emit('sendtoclassic', strdata );
          else if(dvid == 7)
                        socket.emit('sendtoscience', strdata );
          else if(dvid == 8)
                        socket.emit('sendtohealth', strdata );
          else if(dvid == 9)
                        socket.emit('sendtoculture', strdata );
          else if(dvid == 10)
                        socket.emit('sendtolearning', strdata );
	else
            socket.emit('sendtopublic', strdata );
          }
          else  if(vtpid == '2'){
             socket.emit('sendtopvtvilla', strdata );
           }
         }
       }
   }
    catch (e) {
  
   }

   //event.preventDefault();
  };
const userchangevilla = (event:any) => {
const userid = Usersession.getUserId();
 const dvid = Usersession.getVillaId();

const vtpid = Usersession.getVillatype();

const objuser = Usersession.getUserpfp();
const pfid = objuser.pfpid;
const utp = objuser.utf;
const name = objuser.uname;
const utpid = objuser.utpid;

 const pfpobj = {uid:userid,pfpid:pfid,utf:utp,uname:name,x:'200px',y:'100px',vid:dvid};
const strdata = JSON.stringify(pfpobj);
//alert(strdata);
try {
             socket.emit('changedvilla', strdata );
     }
    catch (e) {
  
   }

   event.preventDefault();
  };

const scrolling=()=>{
const buffer = document.getElementById('chatscrollarea') as HTMLElement;
if(buffer){
  buffer.scrollTop = buffer.scrollHeight;

}
};

  return (
    <div>
      <div style={{display:'none'}}>Status: {socket.connected ? 'Connected' : 'Disconnected'}</div>
      {
        <div>
 <div className="per100" id="postmain">
	 <div id="chatscrollarea" onScroll={scrolling} className="postinchat" style={{overflowX:'hidden',overflowY:'auto',height:'50vh'}}>
	  <div className="postingchatdiv">

	    <table className="postingtable" style={{height:'auto'}}>
		
		
		
		<tbody>
			{receivedData.map((row,index)=>(
                      
			<tr>
                           {row.uid > 0 ?(
			   <td>
                           
			    <div style={{width:'100%'}}>
                        	<div className='chatimgdv'>
				{row.utype ?(
	  			 <Girlspfp  itemid={row.pfpid} wth={'20px'}  hgt={'20px'}/>

          			):(
          			
                               <Boyspfp  itemid={row.pfpid} wth={'20px'}  hgt={'20px'}/>

				)}
				
			     </div>
                             <div style={{color:row.code}} className='chatunamedv' >
			   	{row.uname}
			      </div> 
			   </div>
                          <div style={{width:'100%',height:'auto'}}>
                            <div className='chatimgdv'>
			    </div>	
			     <div style={{color:row.code,backgroundColor:'transparent'}} className='chatunamedv' >
			   	{row.msg}
			      </div> 

			   </div>
                         
			   </td>
                            ):(<td></td>) }	
			</tr>
                       
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>
        </div>
      }
    <input id="btnsendmsgtosrv"  style={{display:'none'}} type="submit" value="send" onClick={e=>sendMessage(e)} />
    <input id="btnchangevilla"  style={{display:'none'}} type="submit" value="Changevilla" onClick={e=>userchangevilla(e)} />

    </div>
  );
};

export default ReceiverPublicvilla;
